/**
 * Shared layout breakpoints for Emotion styled components.
 * Values match existing conventions across MainViewHeader (700),
 * admin grids / PivotPointsListView (900), and workshop sidebar (1024).
 */
export const breakpoints = {
  sm: 700,
  md: 900,
  lg: 1024,
};

/** Emotion `@media` helpers — e.g. `${media.sm} { ... }` */
export const media = {
  sm: `@media (max-width: ${breakpoints.sm}px)`,
  md: `@media (max-width: ${breakpoints.md}px)`,
  lg: `@media (max-width: ${breakpoints.lg}px)`,
  minSm: `@media (min-width: ${breakpoints.sm + 1}px)`,
  minMd: `@media (min-width: ${breakpoints.md + 1}px)`,
  minLg: `@media (min-width: ${breakpoints.lg + 1}px)`,
};

export default breakpoints;
